function normalizeCountry(country) {
  var normalized = (country || "").toString().toLowerCase().trim();
  if(typeof normalized.normalize === "function") {
    normalized = normalized.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  return normalized;
}

export function countryKey(country) {
  var keys = {
    "osterreich": "austria",
    "austria": "austria",
    "kroatien": "croatia",
    "croatia": "croatia",
    "polen": "poland",
    "poland": "poland",
    "rumanien": "romania",
    "romania": "romania",
    "schweiz": "switzerland",
    "switzerland": "switzerland",
    "serbien": "serbia",
    "serbia": "serbia",
    "slowakei": "slovakia",
    "slovakia": "slovakia",
    "slowenien": "slovenia",
    "slovenia": "slovenia",
    "tschechien": "czech_republic",
    "czechia": "czech_republic",
    "czech republic": "czech_republic",
    "ungarn": "hungary",
    "hungary": "hungary"
  };
  return keys[normalizeCountry(country)] || "";
}

export function countryLabel(vm, country) {
  var key = countryKey(country);
  var path = "countries." + key;
  if(key && vm && vm.$te && vm.$te(path)) {
    return vm.$t(path);
  }
  return country;
}

export function countryListLabel(vm, countries) {
  if(!countries) return "";
  return countries
    .toString()
    .split(",")
    .map(function(country) {
      return countryLabel(vm, country.trim());
    })
    .join(", ");
}
